/* eslint-disable no-nested-ternary */
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { SearchOutlined } from '@ant-design/icons';
import debounce from 'lodash.debounce';
import {
  Table, Pagination, Tooltip, Select, Input,
} from 'antd';
import qs from 'qs';
import { countRequests, listRequests } from '../../services/Admin';
import { displayMetrics, getLinkStatusEmoji, getRequestStatusEmoji } from '../../utils/utils';

function Requests() {
  // Pagination
  const location = useLocation();
  const history = useHistory();
  const search = qs.parse(location.search, { ignoreQueryPrefix: true });
  const currentPage = +search.page || 1;
  const onPaginationChange = (page) => {
    const newSearch = {
      ...search,
      page,
    };
    history.push({
      ...location,
      search: qs.stringify(newSearch),
    });
  };
  // Search
  const onSearchChange = (e) => {
    const newSearch = {
      ...search,
      q: e.target.value,
      page: 1,
    };
    history.push({
      ...location,
      search: qs.stringify(newSearch),
    });
  };
  // Filter
  const reqFilter = search.f || 'ALL';
  const onFilterChange = (f) => {
    const newSearch = {
      ...search,
      f,
    };
    history.push({
      ...location,
      search: qs.stringify(newSearch),
    });
  };
  // Data retrieving
  const { isLoading, data: requests } = useQuery(
    ['listRequests', currentPage, reqFilter, search.q],
    () => listRequests({ page: currentPage, f: reqFilter, q: search.q }),
    { cacheTime: 0 },
  );
  const { data: count, isLoading: isCountLoading } = useQuery(
    ['countRequests', reqFilter, search.q],
    () => countRequests({ f: reqFilter, q: search.q }),
    { cacheTime: 0 },
  );
  return (
    <div id="Users">
      <div className="Filters">
        <Select
          value={reqFilter}
          style={{ width: 150, marginRight: 8 }}
          onChange={onFilterChange}
        >
          <Select.Option value="ALL">All</Select.Option>
          <Select.Option value="DONE">Done</Select.Option>
          <Select.Option value="ACCEPTED">Accepted</Select.Option>
          <Select.Option value="REJECTED">Rejected</Select.Option>
          <Select.Option value="PENDING">Pending</Select.Option>
          <Select.Option value="EXPIRED">Expired</Select.Option>
        </Select>
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search in domain name"
          defaultValue={search.q || ''}
          style={{ width: 260 }}
          onChange={debounce(onSearchChange, 500)}
          allowClear
        />
        <div style={{ flex: 1 }} />
        <Pagination
          current={currentPage}
          onChange={onPaginationChange}
          total={count}
          pageSize={20}
          showSizeChanger={false}
        />
      </div>
      <Table
        dataSource={requests}
        loading={isLoading}
        pagination={false}
        rowKey="_id"
        size="small"
      >
        <Table.Column
          title=""
          key="_id"
          render={(_, br) => (
            <Tooltip title={br.status} placement="right">
              {getRequestStatusEmoji(br.status)}
            </Tooltip>
          )}
        />
        <Table.Column
          title={`From (${isCountLoading ? '...' : count})`}
          key="_id"
          render={(_, br) => (
            <>
              <a href={`#/domains/?q=${br.from.name}`}>
                {br.from.name}
              </a>
              {br.from._id === br.initiatedBy ? ' ✔️' : ''}
            </>
          )}
        />
        <Table.Column
          title=""
          key="_id"
          render={(_, br) => displayMetrics(br.from)}
        />
        <Table.Column
          title="To"
          key="_id"
          render={(_, br) => (
            <>
              <a href={`#/domains/?q=${br.to.name}`}>
                {br.to.name}
              </a>
              {br.to._id === br.initiatedBy ? ' ✔️' : ''}
            </>
          )}
        />
        <Table.Column
          title=""
          key="_id"
          render={(_, br) => displayMetrics(br.to)}
        />
        <Table.Column
          title=""
          key="_id"
          render={(_, br) => (
            <Tooltip title={br.instructions}>
              {br.instructions ? '📝' : '-'}
            </Tooltip>
          )}
        />
        <Table.Column
          title="Link / Reason / Expiration"
          key="_id"
          render={(_, br) => (
            <div style={{ minWidth: 500 }}>
              {(
                br.status === 'DONE'
                  ? (
                    <>
                      <Tooltip title={br.linkStatus}>
                        {getLinkStatusEmoji(br.linkStatus)}
                      </Tooltip>
                      {' '}
                      <a href={br.url} target="_blank" rel="noreferrer">
                        {br.anchorText}
                      </a>
                    </>
                  )
                  : (
                    br.status === 'REJECTED'
                      ? `💬 "${br.rejectInternalReason}"`
                      : (
                        br.status === 'PENDING'
                          ? `⏳ Expire ${moment(br.startedAt).add(7 * 24, 'hours').format('YYYY-MM-DD @ HH:mm')}`
                          : (
                            br.status === 'ACCEPTED'
                              ? `⏳ Expire ${moment(br.acceptedAt).add(7 * 24, 'hours').format('YYYY-MM-DD @ HH:mm')}`
                              : '-'
                          )
                      )
                  )
              )}
            </div>
          )}
        />
      </Table>
    </div>
  );
}

Requests.propTypes = {
};

export default Requests;
